import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useGncHistory from '../hooks/useGncHistory'

import NoAccess from '../components/psc/lib/NoAccess'

const RedirectToLatest = (props) => {
    const type = props.type
    
    const {
        replaceCurrentPath,
    } = useGncHistory()
    
    const navigate = useNavigate()

    const { objID } = useParams()
    const { projectID } = useParams()
    const [ noAccess, setNoAccess ] = useState(false)

    useEffect(() => {
        fetch('/v0/'+type+'/'+objID+'/latest', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                const latest = json.result
                if (!latest) {
                    setNoAccess(true)
                    return null
                }
                const path = projectID
                           ? '/portfolio/'+projectID+'/'+type+'/'+latest.id
                           : '/' + type + '/' + latest.id
                replaceCurrentPath(path)
                navigate(path)
                return null
            })
        
    }, [])
    
    if (noAccess) {
        return <NoAccess />
    }
    
    return null
};

export default RedirectToLatest
